module.exports = __webpack_public_path__ + "img/settings.d326401b.svg";